<template>
    <div class="vertFlex tdiv" v-if="showTutorial">
      <div v-if="tutorialExists && tutorialIndex>0" class="vertFlex">
        <!-- <label>Tutorial</label> -->
        <div v-if="tutorialIndex<=tutorialMaxIndex" class="vertFlex">
          <!-- <label>Step {{ currentTutorialStep  }} of {{ tutorialLastStep  }} {{currentTutorialStepName}}</label> -->
          <label class="tdesc">{{currentTutorialStepDescription}}</label>
          <div class="horizFlexCenter">
              <button class="tbutton" @click="tutorialPrevious">Back</button> 
              <!-- <button class="tbutton"  @click="tutorialNext">Next</button>   -->
              <!-- <button class="tbutton" @click="tutorialDone">Done</button> -->
          </div>
        </div>
        <div v-if="tutorialIndex>tutorialMaxIndex" class="vertFlex">
          <label>You finished your last step!</label>
          <div class="horizFlexCenter">
              <button class="tbutton" @click="tutorialDone">Done</button>
          </div>
        </div>
        
      </div>
      <div v-if="tutorialExists && tutorialIndex==0" class="vertFlex">
        <label>Tutorial</label>
        <div class="horizFlexCenter">

            <button class="tbutton"  @click="tutorialNext">Start Tutorial!</button>  

        </div>
      </div>
      <div v-if="!tutorialExists">
        <label>There is no tutorial available for this application</label>
      </div>
        
    </div>
</template>

<script>
import tutorialhelper from '../../services/tutorialhelper.js'
export default {
    name:'tutorial',
    props:{
    
    },
      mixins:[tutorialhelper],
}
</script>

<style scoped>
.buttontext{
  margin:0px;
}

.button{
    
    
    border: none;
    border-radius:10px;
    width:130px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
}
button:hover{
  font-weight: bolder;
    /* background-color:var(--highlight-color);
    color:var(--light-text-color); */
  cursor:pointer;
}
button:disabled{
  background-color:gray;
  color:var(--light-text-color);
}
.buttonprimary{
  background-color:var(--button-color);
  color:var(--light-text-color);
}
.buttonhighlight{
  background-color:var(--highlight-button-color);
  color:var(--light-text-color);
}
.buttondisabled{
  background-color:var(--disabled-color);
  color:var(--light-text-color);
}
.buttonpay{
  background-color:var(--pay-color);
  color:var(--light-text-color);
}
.buttonmeal{
  background-color:var(--meal-color);
  color:var(--light-text-color);
}
.tdesc{
  font-size: smaller;
}
.tbutton{
 margin:2px;
  border:1px solid gray;
  background-color: transparent;
  border-radius: 2px;
  font-size:inherit;
}
.tdiv{
  border:2px solid rgb(221, 95, 221);
  padding:5px;
  border-radius: 5px;
  margin:5px;
  background-color: rgb(250, 231, 250);;
}
</style>